module.exports = __webpack_public_path__ + "6cdb12e73a7276e90ca566657ca7cc27.png";